import { merge } from 'lodash';
import { createReducer } from '@reduxjs/toolkit';
import { UPDATE_OPTIONS } from '../constants/actionTypes';
import { PRESETS } from '../constants/general';
import { OptionsState } from '../types';

export const optionsInitialState: OptionsState = {
  selectedThemeIndex: 0,
  selectedAssetIndex: 0,
  selectedLogoIndex: 0,
  selectedPresets: {
    original: true,
    square: true,
    'landscape-16:9': true,
    'landscape-4:3': true,
    'portrait-3:4': true,
    'portrait-9:16': true,
    custom: false,
  },
  customPreset: {
    params: {
      label: '',
      width: null,
      height: null,
    },
  },
  presetsOrder: PRESETS,
  toggleAspectRatio: true,
  aspectRatioLock: true,
  flip: true,
  rotate: true,
  unselectedOverlayIndexes: {},
  selectedOverlayPlacements: {
    top_left: true,
    top_right: true,
    bottom_right: true,
    bottom_left: true,
    middle: true,
  },
  selectedExportQualities: {
    auto: true,
    best: true,
    good: true,
    eco: true,
    low: true,
  },
  selectedExportFormats: {
    jpg: true,
    png: true,
    webp: true,
  },
  download: true,
  share: true,
  activeSteps: {
    resizeAndCrop: true,
    imageOverlay: true,
    textOverlays: true,
    export: true,
  },
  textPresets: {
    heading: true,
    subtitle: true,
    body: true,
    caption: true,
  }
};

export const options = createReducer(
  optionsInitialState,
  {
    [UPDATE_OPTIONS]: (
      state: OptionsState,
      resp: {
        payload: Partial<OptionsState>;
      }
    ) => {
      return merge(state, resp.payload);
    },
  },
);
